import React, { useEffect, useState } from "react";
import { Carousel, Spin } from "antd";
import { useData } from "../../contexts/DataContext";
import {
  fetchCarouselLandscapeImages,
  fetchCarouselPortraitImages,
} from "../../services/ApiService";

const CarouselTopPicks: React.FC = () => {
  const { state, dispatch } = useData();
  const [carouselImages, setCarouselImages] = useState(
    state.carouselLandscapeImages
  ); // Initialize carouselImages state as null

  useEffect(() => {
    // Check if carouselImages data has already been fetched
    if (state.isMobile) {
      if (!state.carouselPortraitImages) {
        fetchCarouselPortraitImages(dispatch)
          .then((images) => {
            setCarouselImages(images); // Set carouselImages state after images are fetched
          })
          .catch((error) =>
            console.error("Error fetching portrait images:", error)
          );
      } else {
        setCarouselImages(state.carouselPortraitImages);
      }
    } else {
      if (!state.carouselLandscapeImages) {
        fetchCarouselLandscapeImages(dispatch)
          .then((images) => {
            setCarouselImages(images); // Set carouselImages state after images are fetched
          })
          .catch((error) =>
            console.error("Error fetching landscape images:", error)
          );
      } else {
        setCarouselImages(state.carouselLandscapeImages);
      }
    }
  }, [
    dispatch,
    state.isMobile,
    state.carouselPortraitImages,
    state.carouselLandscapeImages,
  ]); // Add state.isMobile and image states as dependencies

  return (
    <div
      style={{
        width: state.isMobile ? "100%" : "70%",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      {carouselImages ? (
        <Carousel
          autoplay
          autoplaySpeed={5000}
          dotPosition="bottom"
          style={{ outline: "none" }}
        >
          {carouselImages.Images.map((image) => (
            <div key={image.id}>
              <img
                src={`${state.baseApiPath}${image.url}`}
                alt={image.alternativeText || "Featured gallery"}
                style={{
                  width: state.isMobile ? "400px" : "auto",
                  height: state.isMobile ? "auto" : "600px",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <Spin></Spin>
      )}
    </div>
  );
};

export default CarouselTopPicks;
